import React, { Component } from "react";
import { Layout } from "antd";
import Pusher from "react-pusher";
import * as Sentry from "@sentry/react";
import { AppHeader } from "./components/app/AppHeader";
import AppBody from "./components/app/AppBody";
import WebUpgradeContainer from "./components/WebUpgrade/WebUpgradeContainer";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showWebUpgradePrompt: false
    };
  }

  /**
   * @function handleWebUpgradePrompt
   * @desc This function handles toggling web upgrade notification
   */
  handleWebUpgradePrompt = () => {
    this.setState(prevState => ({
      showWebUpgradePrompt: !prevState.showWebUpgradePrompt
    }));
  };

  render() {
    const { showWebUpgradePrompt } = this.state;
    return (
      <div id="wrapper">
        <Layout>
          <Pusher
            channel={process.env.REACT_APP_PUSHER_CHANNEL}
            event={`new_deployment_${process.env.REACT_APP_ENVIRONMENT}_admin`}
            onUpdate={this.handleWebUpgradePrompt}
          />

          {showWebUpgradePrompt && (
            <WebUpgradeContainer
              handleWebUpgradePrompt={this.handleWebUpgradePrompt}
            />
          )}
          <AppHeader />
        </Layout>
        <Layout className="pt-50">
          <AppBody />
        </Layout>
      </div>
    );
  }
}

export default Sentry.withProfiler(App, { name: "KulcareAdmin" });
